import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=2a71749c&scoped=true&"
import script from "./FirstPage.vue?vue&type=script&lang=js&"
export * from "./FirstPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=2a71749c&prod&scoped=true&lang=css&"
import style1 from "./FirstPage.vue?vue&type=style&index=1&id=2a71749c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a71749c",
  null
  
)

export default component.exports